import { gql } from "@apollo/client";

export const CHANGE_SLIDE = gql`
subscription ChangeSlide($code: Float) {
  changeSlide(code: $code) {
    activeSlide
    presentId
    status
  }
}`

export const PARTICIPANT_JOINED = gql`
subscription ParticipantJoined($code: Float) {
  participantJoined(code: $code) {
    _id
    uuid
    name
  }
}`

export const ANSWER_CREATED = gql`
subscription AnswerCreated($code: Float) {
  answerCreated(code: $code) {
    _id
    answer
    createdAt
    participantId
    slideId
  }
}`